import * as api from '../../api'
import {AmplifyEventBus} from "aws-amplify-vue";


const state = {
    sent_duty_email_response: [],
    menu_banner_type: 0,
    dont_sign_out: 1, // set to 1 for test dont sign out at the end
    is_day_direct_link: 0, // to detect that we have a direct call (no menu)
    sales_tasks_details: [],
    leaflink_customers_selected: [],
    task_list_data: [],
}

const getters = {
    dont_sign_out: state => state.dont_sign_out,
    sales_tasks_details: state => state.sales_tasks_details,
    leaflink_customers_selected: state => state.leaflink_customers_selected,
    sent_duty_email_response: state => state.sent_duty_email_response,
    is_day_direct_link: state => state.is_day_direct_link,
    task_list_data: state => state.task_list_data,
}

const mutations = {

    getTaskDetail: (state, payload) => {
        api.getTaskDetail(
            {task_date: payload.task_date, sales_person_hash: payload.sales_person_hash,
                action_type: payload.action_type, field: payload.field , value: payload.value,
                task_id: payload.task_id , task_hash: payload.task_hash
            }, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.sales_tasks_details = val.data
        })
    },

    getTaskList: (state, payload) => {
        api.getTaskList({days_back: payload.days_back}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.task_list_data = val.data
        })
    },

    sendDutyListEmail: (state, payload) => {
        api.sendDutyListEmail(
            {task_date: payload.task_date, sales_person_hash: payload.sales_person_hash}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.sent_duty_email_response = val.data
        })
    },

    getCustomerListResults: (state, payload) => {
        api.getCustomerListResults(
            {searchstring: payload.searchstring}, { 'authorization': payload.token }).then(val => {
            if(val.data['SESSION'] == "EXPIRED") { AmplifyEventBus.$emit('authState', 'signedOut');}
            state.leaflink_customers_selected = val.data
        })
    },

}

const actions = {

    setDontSignOut: () => {
        state.dont_sign_out = 1; // if we cll a detail page from the CA map we can't sign out or the next detail page will be signed out
    },
    setDayDirectLink: () => {
        state.is_day_direct_link = 1;
    },
    getTaskDetail: (context, payload) => {
        context.commit('getTaskDetail', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    getTaskList: (context, payload) => {
        context.commit('getTaskList', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    sendDutyListEmail: (context, payload) => {
        context.commit('sendDutyListEmail', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
    getCustomerListResults: (context, payload) => {
        context.commit('getCustomerListResults', { ...payload, token: context.rootGetters['auth/getWebUserToken'], webUser: context.rootState.auth.web_user })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

